module.exports = __webpack_public_path__ + "img/fig09.09a2fb87.jpg";